module.exports = __webpack_public_path__ + "img/14.479d6fd7.png";